import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'panier-header',
  templateUrl: './panier-header.component.html'
})
export class PanierHeaderComponent implements OnInit {

  constructor(
  	private router: Router,
  ) { }

  url: string;
  step: number;

  ngOnInit() {
  	this.url = this.router.url;

  	if(this.url.includes('mon-panier') || this.url.includes('justificatifs') || this.url.includes('identification')){
  		this.step = 1;
  	} else {
  		this.step = (this.url.includes('paiement') || this.url.includes('confirmation')) ? 3 : 2;
  	}

  }

}



// WEBPACK FOOTER //
// ./src/app/shared/panier-helpers/panier-header.component.ts